import _classCallCheck from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/app/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React from 'react';
export var PageComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(PageComponent, _React$Component);

  var _super = _createSuper(PageComponent);

  function PageComponent() {
    _classCallCheck(this, PageComponent);

    return _super.apply(this, arguments);
  }

  return PageComponent;
}(React.Component);